import { Link } from 'react-router-dom';
import { getHotArticles, formatViews } from '@/utils/articles';

export default function HotRanking() {
  const list = getHotArticles(8);
  return (
    <div className="rounded-lg border border-background-200 bg-background-50 p-4">
      <div className="mb-3 flex items-center justify-between border-b border-background-200 pb-2">
        <h3 className="flex items-center gap-2 text-base font-black text-foreground-950">
          <i className="ri-fire-fill text-accent-500"></i>
          热门爆料榜
        </h3>
        <Link
          to="/hot"
          className="cursor-pointer whitespace-nowrap text-xs font-medium text-primary-600 hover:text-primary-700"
        >
          完整榜单
        </Link>
      </div>
      <ul>
        {list.map((item, idx) => (
          <li key={item.id}>
            <Link
              to={`/detail/${item.id}`}
              className="group flex cursor-pointer items-start gap-3 border-b border-background-100 py-2.5 last:border-0"
            >
              <span
                className={`flex h-5 w-5 shrink-0 items-center justify-center rounded font-label text-xs font-bold ${
                  idx < 3
                    ? 'bg-accent-500 text-background-50'
                    : 'bg-background-200 text-foreground-500'
                }`}
              >
                {idx + 1}
              </span>
              <span className="min-w-0 flex-1">
                <span className="clamp-2 block text-sm leading-snug text-foreground-800 transition-colors group-hover:text-primary-600">
                  {item.title}
                </span>
                <span className="mt-1 flex items-center gap-1 text-xs text-foreground-400">
                  <i className="ri-eye-line"></i>
                  {formatViews(item.views)}
                </span>
              </span>
            </Link>
          </li>
        ))}
      </ul>
    </div>
  );
}